import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    // component: window.IsUseApp
    //   ? () => import('../views/renlian/renliandenglu.vue')
    //   : Home
    component: Home
  },
  {
    path: '/login',//人脸登录/选择基本信息（根据配置自动判断）
    name: 'Login',
    component: () => import('../views/renlian/index.vue')
  },
  {
    path: '/shibie',//人脸识别
    name: 'Shibie',
    component: () => import('../views/renlian/renlianshibie.vue')
  },
  {
    path: '/xuanzejibenxinxi',//客户基本信息
    name: 'Xuanzejibenxinxi',
    component: () => import('../views/xuanzejibenxinxi/index.vue')
  },
  {
    path: '/cepingsm',//客户服务等级评价说明
    name: 'Cepingsm',
    component: () => import('../views/kehufengxiandengjiceping/shuoming.vue')
  },
  {
    path: '/ceping',//客户服务等级评价
    name: 'Ceping',
    component: () => import('../views/kehufengxiandengjiceping/index.vue')
    // component: () => import('../views/kehufengxiandengjiceping/index-wuyuyin.vue')
  },
  {
    path: '/cepingjieguo',//客户服务等级评价结果
    name: 'CepingJieguo',
    component: () => import('../views/kehufengxiandengjiceping/jieguo.vue')
  },
  {
    path: '/pingfenxiangqing',//评分详情
    name: 'PingfenXiangqing',
    component: () => import('../views/kehufengxiandengjiceping/pingfenxiangqing.vue')
  },
  {
    path: '/cepingfuwuti',//客户服务等级评价-附加题
    name: 'CepingFuwuti',
    component: () => import('../views/kehufengxiandengjiceping/followup.vue')
  },
  {
    path: '/aimoxingyucanshu',//AI模型选择与参数配置
    name: 'Aimoxingyucanshu',
    component: () => import('../views/aimoxingyucanshu/index.vue')
  },
  {
    path: '/jisuanluoji',//计算逻辑
    name: 'Jisuanluoji',
    component: () => import('../views/aimoxingyucanshu/CalcLogic.vue')
  },
  {
    path: '/tiaozhengzichanbili',//调整资产配置
    name: 'Tiaozhengzichanbili',
    component: () => import('../views/tiaozhengzichanbili/index.vue')
  },
  {
    path: '/jiaoyishuju',//交易数据折线图
    name: 'Jiaoyishuju',
    component: () => import('../views/tiaozhengzichanbili/jiaoyishuju.vue')
  },
  {
    path: '/lishihuice',//历史回测参数设置
    name: 'Lishihuice',
    component: () => import('../views/lishihuice/index.vue')
  },
  {
    path: '/lishihuicejieguo',//历史回测参数设置结果
    name: 'LishihuiceJieguo',
    component: () => import('../views/lishihuice/jieguo.vue')
  },
  {
    path: '/yaliceshi',//压力测试·极端风险检验
    name: 'Yaliceshi',
    component: () => import('../views/yaliceshi/index.vue')
  },
  {
    path: '/yaliceshijieguo',//压力测试·极端风险检验结果
    name: 'YaliceshiJieguo',
    component: () => import('../views/yaliceshi/jieguo.vue')
  },
  {
    path: '/touzibaogao',//投资报告
    name: 'Touzibaogao',
    component: () => import('../views/touzibaogao/index.vue')
  },
]

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 页面切换时停止所有正在播放的音频
router.beforeEach((to, from, next) => {
  Vue.prototype.stopAllAudio()
  next()
})

export default router